import { Component, ElementRef, HostListener, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Appointment } from "src/app/models/appointment.model";
import { AppointmentCollectionService } from "src/app/services/admin/appointment-collection.service";
import * as moment from 'moment-timezone';
import { Patient } from "src/app/models/patient.model";
import { PatientService } from "src/app/services/patient.service";
import { RelevantLabService } from "src/app/services/relevant-lab.service";
import { Expert } from "src/app/models/expert.model";
import { ExpertService } from "src/app/services/admin/expert.service";
import { DoctorService } from "src/app/services/admin/doctor.service";
import { Doctor } from "src/app/models/doctor.model";
import { Location } from "@angular/common";
import { OrgCollectionService } from "src/app/services/org-location-collection.service";
import { OrgLocation } from "src/app/models/org-location.model";
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { NewLocationFormModel } from "src/app/models/forms/new-location-form.model";
import { SpecialtiesCollectionService } from "src/app/services/specialties-collection.service";
import { Specialty } from "src/app/models/specialty.model";
import { SubSpecialty } from "src/app/models/sub-specialty.model";
import { SearchExpertFormModel } from "src/app/models/forms/search-expert-form.model";
import { NotificationService } from '@progress/kendo-angular-notification';
import { EmailNotificationService } from "src/app/services/notification.service";
import * as utils from '../../utils/utility-functions';
import { LogService } from "src/app/services/logging.service";
import { AppointmentLog } from "src/app/models/log.model";
import { LogType } from "src/app/models/log-type";
import { AdminNotesService } from "src/app/services/admin/admin-notes.service";
import { UserTypeEnum } from "src/app/models/user-type";
import { NotificationType } from "src/app/models/notification-type.model";
import { Subscription } from "rxjs";
import { RelevantLab } from "src/app/models/relevant-lab.model";
import { take } from "rxjs/operators";
import { ConsultationType } from "src/app/models/consultation-type";
import { phone } from 'phone';


@Component({
  selector: 'app-appointment-component',
  templateUrl: './appointment.component.html',
  styleUrls: ['./appointment.component.css']
})
export class AppointmentComponent implements OnInit, OnDestroy {
  sort: 'asc' | 'desc' = 'asc';

  public specialtyFormGroup: UntypedFormGroup;
  public adminResolutionNoteFormGroup: UntypedFormGroup;
  public adminNoteFormGroup: UntypedFormGroup;
  public submitRequestForm: UntypedFormGroup;

  receivedRequestedInfoSelected = null;

  expertFoundOpened = false;
  formErrorOpen = false;

  // Message all values for kendo dialog
  allReminderOpen = false;
  allMessages = [];
  allMessage = '';

  // Replace expert
  replaceExpertOpen = false;
  replacementExpert: Expert;

  // Reminder message
  doctorSubject = null;
  doctorMessageString = null;
  reminderOpen = false;
  expertReminderOpen = false;
  doctorReminderOpen = false;
  locationReminderOpen = false;
  doctorMessages = [];
  doctorMessage = '';
  expertMessages = [];
  expertMessage = '';
  locationMessages = [];
  locationMessage = '';

  // CIMA messages
  cimaSelectionoOpen = false;
  cimaDoctorSelectionoOpen = false;
  cimaExpertSelectionoOpen = false;
  cimaLocationSelectionoOpen = false;

  // CIMA selection
  selectedLocationOption = 'In App / Push Message';
  selectedExpertOption = 'In App / Push Message';
  selectedDoctorOption = 'In App / Push Message';
  selectedAllOption = 'In App / Push Message';

  // Status change values for kendo dialog
  statusChangeOpen = false;
  statusChangeText = '';

  // Add to calendar status
  addToCalendarOpen = false;

  //Appointment info
  private appointmentId: string = '';
  appointment: Appointment;
  appointment$: Subscription;
  date = '';
  time = '';
  timeSince = '';
  timeSinceUnit = '';
  timeSinceUpdated = '';
  timeSinceUnitUpdated = '';

  //Patient info
  patient: Patient
  patient$: Subscription

  // Expert info
  expert: Expert;
  expert$: Subscription;
  experts: Expert[] = [];
  expertListLoaded = false;
  expertDataLoaded = false;

  // Doctor info
  doctor: Doctor;
  doctor$: Subscription;

  // Org location
  orgLocation: OrgLocation;
  orgLocation$: Subscription;


  // Relevant labs
  relevantLabList: RelevantLab[];
  relevantLabList$: Subscription;

  //Consult details
  isConsultVideoLoaded = false;
  // Consult details - time
  withinTime = false;
  pastTime = false;

  // Seearch expert column
  searchExperts = false;

  // Search doctor column
  searchDoctors = false;

  // Specialty
  specialtyArray: Specialty[] = [];
  selectedSpecialty: Specialty;
  isSubSpecialtyLoaded = false;
  subSpecialtyListArray: SubSpecialty[] = [];
  subSpecialtyMain: SubSpecialty[] = [];
  selectedSubSpecialties = new SubSpecialty();
  isDisabledSubSpecialties = true;
  isSearchAvailable = false;

  // Close appointment
  closeAppointmentOpen = false;

  // dataResultProducts
  dataResultsSubSpecialties: SubSpecialty[] = [];

  // Single invited expert
  singleInvitedExpert: Expert;

  // Event Logs
  eventLogs: AppointmentLog[];
  eventLogs$: Subscription;

  // Admin notes
  adminNotes: any[] = [];
  adminNotes$: Subscription;

  // Doctor messages
  doctorMessagesList: any[] = [];
  doctorMessagesList$: Subscription;

  // Expert messages
  expertMessagesList: any[] = [];
  expertMessagesList$: Subscription;

  // Location messages
  locationMessagesList: any[] = [];
  locationMessagesList$: Subscription;

  // Times available
  days = [];
  daysLoaded = false;

  timezone = '';
  currenntTimezone = '';
  doctorCurrentTime: any;
  expertCurrentTime: any;
  doctorAppointmentTime: any;
  expertAppointmentTime: any;

  confirmAppointmentError = false;

  // Update time
  public value: Date = new Date(2019, 5, 1, 22);
  public format = "MM/dd/yyyy hh:mm a";
  public steps: any = {
    minute: 15
  };
  updateTime = false;

  public formValue: NewLocationFormModel | null = {
    locationName: "Test",
    organization: null
  };

  public newFormValue: SearchExpertFormModel | null = {
    specialty: null,
    subSpecialty: null
  }

  patientSubscription: Subscription;



  constructor(
    private location: Location,
    private notificationService: NotificationService,
    private route: ActivatedRoute,
    private appointmentCollectionService: AppointmentCollectionService,
    private patientService: PatientService,
    private relevantLabService: RelevantLabService,
    private expertService: ExpertService,
    private doctorService: DoctorService,
    private orgCollectionService: OrgCollectionService,
    private specialtyCollectionService: SpecialtiesCollectionService,
    private emailNotificationService: EmailNotificationService,
    private logService: LogService,
    private adminNotesService: AdminNotesService,
    private el: ElementRef,
    private router: Router) {
    this.appointmentId = this.route.snapshot.paramMap.get('id');
    this.setFormValues();
    this.sortWeek();

    // Get reminder messages
    this.doctorMessages = utils.getDoctorReminderMessages();
    this.expertMessages = utils.getExpertReminderMessages();
    this.locationMessages = utils.getLocationReminderMessages();
    this.allMessages = utils.getSendToAllMessages();
  }

  ngOnInit() {
    this.currenntTimezone = moment.tz(moment.tz.guess()).format('z');

    this.appointment$ = this.appointmentCollectionService.findAppointmentByID$(this.appointmentId)
      .subscribe(appointment => {
        this.appointment = appointment;
        localStorage.setItem('currentAppointment', JSON.stringify(appointment));

        this.getPatient(appointment.patient_id);
        this.getOrgLocation(appointment.org_location_id);
        this.getRelevantLabList(appointment.patient_id, appointment.id);
        this.getExpert(appointment.expert_id);
        this.getDoctor(appointment.doctor_id);

        this.getDoctorMessages(appointment.id);
        this.getExpertMessages(appointment.id);
        this.getLocationMessages(appointment.id);

        this.value = new Date(appointment.appointment_date);

        let momentDate = moment(this.appointment.appointment_date);

        //Check if time is within 15 minutes
        let currentTime = moment();
        let timeDiff = momentDate.diff(currentTime, 'minutes');
        if (timeDiff >= -15 && timeDiff <= 15) {
          this.withinTime = true;
        } else if (timeDiff < -15) {
          this.pastTime = true;
        }
      });

    this.getEventLogs(this.appointmentId);
    this.getAdminNotes(this.appointmentId);

    const testDate = new Date().toString().match(/([A-Z]+[\+-][0-9]+.*)/)[1];
    this.timezone = testDate;

    this.specialtyCollectionService.getSpecialtyListAsync().pipe(take(1)).subscribe(specialtyArray => {
      this.specialtyArray = specialtyArray;
      this.selectedSpecialty = this.specialtyArray[0];
    });

    this.specialtyCollectionService.getSubSpecialtyListAsync().pipe(take(1)).subscribe(subSpecialtyArray => {
      this.subSpecialtyListArray = subSpecialtyArray;
      this.updateSubSpecialtyList(0);
    });

    this.expertService.currentExperts.subscribe(experts => {
      this.experts = experts;
      if (this.searchExperts) {
        this.expertListLoaded = true;
        this.searchExperts = false;
      }

    });
  }

  ngOnDestroy() {
    this.orgLocation$?.unsubscribe();
    this.patient$?.unsubscribe();
    this.eventLogs$?.unsubscribe();
    this.relevantLabList$?.unsubscribe();
    this.expert$?.unsubscribe();
    this.doctor$?.unsubscribe();
    this.appointment$?.unsubscribe();
    this.adminNotes$?.unsubscribe();
    this.doctorMessagesList$?.unsubscribe();
    this.expertMessagesList$?.unsubscribe();
    this.locationMessagesList$?.unsubscribe();
  }

  copyToClipboard(text: string) {
    const tempInput = document.createElement('input');
    document.body.appendChild(tempInput);
    tempInput.setAttribute('value', text);
    tempInput.select();
    document.execCommand('copy');
    document.body.removeChild(tempInput);
    this.notificationService.show({
      content: 'Text copied to clipboard:' + text,
      animation: { type: 'slide', duration: 500 },
      position: { horizontal: 'center', vertical: 'bottom' },
      type: { style: 'success', icon: true },
      hideAfter: 3000
    });
    // alert('Text copied to clipboard: ' + text);
  }

  handleChangeUrgent() {
    // if appointment is urgent, change to urgent to false
    // also check if appointment is non urgent and confirmed, changed urgent confirmed to true
    if (this.appointment.urgent) {
      this.appointment.urgent = false;
      this.appointment.urgent_confirmed = false;
    } else {
      this.appointment.urgent = true;
      if (this.appointment.confirmed === true) {
        this.appointment.urgent_confirmed = true;
      }
    }
    // save appointment
    this.appointmentCollectionService.adminUpdateAppointmentStatus(this.appointment);

    this.notificationService.show({
      content: 'Appointment updated.  Notifications sent.',
      animation: { type: 'slide', duration: 500 },
      position: { horizontal: 'center', vertical: 'bottom' },
      type: { style: 'success', icon: true },
      hideAfter: 5000
    });
  }

  closeAppointmentDialog() {
    this.closeAppointmentOpen = true;
  }

  openStatusChange() {
    this.statusChangeOpen = true;
  }

  closeStatusChange(status) {
    if (status === 'yes') {
      this.adminNotesService.createAdminNote(this.appointment.id, this.statusChangeText);
      this.handleChangeUrgent();
      this.statusChangeText = '';
      this.statusChangeOpen = false;
    } else {
      this.notificationService.show({
        content: 'Canceled',
        animation: { type: 'slide', duration: 500 },
        position: { horizontal: 'center', vertical: 'bottom' },
        type: { style: 'error', icon: true },
        hideAfter: 2000
      });
      this.statusChangeOpen = false;
    }
  }

  openAddToCalendar() {
    this.addToCalendarOpen = true;
  }

  closeAddToCalendar(status) {
    this.addToCalendarOpen = false;
  }

  addToGoogleCalendar() {
    if (this.appointment.expert_google_event_link != null) {
      window.open(this.appointment.expert_google_event_link);
    }

    this.addToCalendarOpen = false;
  }

  addToYahooCalendar() {
    if (this.appointment.expert_yahoo_event_link != null) {
      window.open(this.appointment.expert_yahoo_event_link);
    }

    this.addToCalendarOpen = false;
  }

  addToAOLCalendar() {
    if (this.appointment.expert_aol_event_link != null) {
      window.open(this.appointment.expert_google_event_link);
    }

    this.addToCalendarOpen = false;
  }

  public closeAppointment(status) {
    if (status === 'yes') {
      // Email and Push EXPERT
      this.emailNotificationService.sendEmailAndPush(
        UserTypeEnum.EXPERT,
        this.expert.id,
        'WTD - Appointment Canceled',
        utils.getCanceledAppointmentMessage(),
        NotificationType.APPOINTMENT_GENERAL,
        this.appointment.id
      )

      // Email and Push DOCTOR
      this.emailNotificationService.sendEmailAndPush(
        UserTypeEnum.DOCTOR,
        this.doctor.id,
        'WTD - Appointment Canceled',
        utils.getCanceledAppointmentMessage(),
        NotificationType.APPOINTMENT_GENERAL,
        this.appointment.id
      )

      this.appointment.consultation = [ConsultationType.CLOSED]
      this.appointment.date_closed = moment().format('x');
      this.appointment.canceled = true;

      this.appointmentCollectionService.resubmitAppointment(this.appointment);
      this.logService.createAppointmentLog(this.appointment.id, LogType.APPOINTMENT_CANCELED);

      this.notificationService.show({
        content: `Appointment Canceled, expert and doctor notified.`,
        animation: { type: 'slide', duration: 500 },
        position: { horizontal: 'center', vertical: 'bottom' },
        type: { style: 'success', icon: true },
        hideAfter: 2000
      });
      this.closeAppointmentOpen = false;
    } else {
      this.notificationService.show({
        content: 'Canceled',
        animation: { type: 'slide', duration: 500 },
        position: { horizontal: 'center', vertical: 'bottom' },
        type: { style: 'error', icon: true },
        hideAfter: 2000
      });
      this.closeAppointmentOpen = false;
    }
  }

  getAdminNotes(appointmentId) {
    this.adminNotes$ = this.adminNotesService.getAdminNotesAsync(appointmentId).subscribe((notes: any[]) => {
      this.adminNotes = notes.sort((a, b) => {
        return Number((b as any).date_created) - Number((a as any).date_created);
      });
    });
  }

  getDoctorMessages(appointmentId) {
    this.doctorMessagesList$ = this.appointmentCollectionService.getDoctorMessages(appointmentId).subscribe(notes => {
      // update doctor messages to be desc
      this.doctorMessagesList = notes.sort((a, b) => {
        return Number((b as any).date_created) - Number((a as any).date_created);
      }
      );
    });
  }

  getExpertMessages(appointmentId) {
    this.expertMessagesList$ = this.appointmentCollectionService.getExpertMessages(appointmentId).subscribe(notes => {
      this.expertMessagesList = notes.sort((a, b) => {
        return Number((b as any).date_created) - Number((a as any).date_created);
      }
      );
    });
  }

  getLocationMessages(appointmentId) {
    this.locationMessagesList$ = this.appointmentCollectionService.getLocationMessages(appointmentId).subscribe(notes => {
      this.locationMessagesList = notes.sort((a, b) => {
        return Number((b as any).date_created) - Number((a as any).date_created);
      }
      );
    });
  }

  getDoctor(doctorId) {
    if (this.doctor$ == null || doctorId !== this.doctor.id) {
      if (this.doctor$) { this.doctor$.unsubscribe() }
      this.doctor$ = this.doctorService.getDoctorByIdAsync(doctorId).subscribe(doctor => {
        this.doctor = doctor;
      });
    }
  }

  getExpert(expertId) {
    if (this.expert$ == null || expertId !== this.expert.id) {
      if (this.expert$) { this.expert$.unsubscribe() }
      this.expert$ = this.expertService.getSingleExpertByIdAsync(expertId).subscribe(expert => {
        this.expert = expert;
        if (this.expert.timezone != null) {
          this.expertCurrentTime = moment().tz(this.expert.timezone.value).format('LT');
          this.expertAppointmentTime = moment(this.appointment.appointment_date).tz(this.expert.timezone.value).format('LT');
        }
      });
    }
  }

  getRelevantLabList(patientId, appointmentId) {
    if (this.relevantLabList$ == null || patientId !== this.patient.id) {
      if (this.relevantLabList$) { this.relevantLabList$.unsubscribe() }
      this.relevantLabList$ = this.relevantLabService.getRelevantLabByPatientIDAppointmentIDAsync(patientId, appointmentId).subscribe(relevantLabList => {
        this.relevantLabList = relevantLabList;
      });
    }
  }

  getEventLogs(appointmentId) {
    if (this.eventLogs$ == null) {
      this.eventLogs$ = this.logService.getAppointmentLogsObservable(appointmentId).subscribe(eventLogs => {
        this.eventLogs = eventLogs;
        this.sortEvents();
      });
    }
  }

  getPatient(patientId) {
    if (this.patient$ == null || patientId !== this.patient.id) {
      if (this.patient$) { this.patient$.unsubscribe() }
      this.patient$ = this.patientService.getPatientById(patientId).subscribe(patient => {
        this.patient = patient;
      });
    }
  }

  getOrgLocation(orgLocationId) {
    if (this.orgLocation$ == null || orgLocationId !== this.orgLocation.id) {
      if (this.orgLocation$) { this.orgLocation$.unsubscribe() }
      this.orgLocation$ = this.orgCollectionService.getOrgLocationAsync(orgLocationId).subscribe(orgLocation => {
        this.orgLocation = orgLocation;
        if (this.orgLocation.timezone != null) {
          this.doctorCurrentTime = moment().tz(this.orgLocation.timezone.value).format('LT');
          this.doctorAppointmentTime = moment(this.appointment.appointment_date).tz(this.orgLocation.timezone.value).format('LT');
        }
      });
    }
  }

  getAge(dateString: string) {
    return utils.getAge(dateString);
  }

  getBMI(patient) {
    return utils.getBMI(patient);
  }

  getHeight(patient) {
    return utils.getHeight(patient);
  }

  sortEvents() {
    // check this.sort, if asc change to desc, if desc change to asc
    if (this.sort === 'asc') {
      this.sort = 'desc';
    } else {
      this.sort = 'asc';
    }

    // sort event logs based on this.sort
    this.eventLogs.sort((a, b) => {
      const dateA: any = a;
      const dateB: any = b;

      if (this.sort === 'asc') {
        return Number(dateA.created_at) - Number(dateB.created_at);
      } else {
        return Number(dateB.created_at) - Number(dateA.created_at);
      }
    });
  };

  public closeAllReminder(status) {
    if (status === 'yes') {
      if (this.allMessage === '' || this.allMessage == null) {
        this.notificationService.show({
          content: 'Please add message',
          animation: { type: 'slide', duration: 500 },
          position: { horizontal: 'center', vertical: 'bottom' },
          type: { style: 'error', icon: true },
          hideAfter: 2000
        });
      } else {
        // Email ALL
        this.emailNotificationService.sendMultipleEmails(
          'WTD - Message',
          [this.orgLocation.email, this.doctor.email, this.expert.email],
          this.allMessage,
          `${this.orgLocation.location_name}`
        );
        // // Email LOCATION
        // this.emailNotificationService.sendEmail(
        //   'WTD - Message',
        //   this.orgLocation.email,
        //   this.allMessage,
        //   `${this.orgLocation.location_name}`
        // );

        // Email and Push DOCTOR
        this.emailNotificationService.sendPushNotificationOnly(
          UserTypeEnum.DOCTOR,
          this.doctor.id,
          'WTD - Message',
          this.allMessage,
          NotificationType.APPOINTMENT_GENERAL,
          this.appointment.id
        )

        // Email and Push EXPERT
        this.emailNotificationService.sendPushNotificationOnly(
          UserTypeEnum.EXPERT,
          this.expert.id,
          'WTD - Message',
          this.allMessage,
          NotificationType.APPOINTMENT_GENERAL,
          this.appointment.id
        )

        // // Email and Push DOCTOR
        // this.emailNotificationService.sendEmailAndPush(
        //   UserTypeEnum.DOCTOR,
        //   this.doctor.id,
        //   'WTD - Message',
        //   this.allMessage,
        //   NotificationType.APPOINTMENT_GENERAL,
        //   this.appointment.id
        // )

        // // Email and Push EXPERT
        // this.emailNotificationService.sendEmailAndPush(
        //   UserTypeEnum.EXPERT,
        //   this.expert.id,
        //   'WTD - Message',
        //   this.allMessage,
        //   NotificationType.APPOINTMENT_GENERAL,
        //   this.appointment.id
        // )

        this.notificationService.show({
          content: 'Sent messages.',
          animation: { type: 'slide', duration: 500 },
          position: { horizontal: 'center', vertical: 'bottom' },
          type: { style: 'success', icon: true },
          hideAfter: 2000
        });

        this.appointmentCollectionService.submitExpertMessage(this.appointment.id, this.allMessage);
        this.appointmentCollectionService.submitDoctorMessage(this.appointment.id, this.allMessage);
        this.logService.createAppointmentLog(this.appointment.id, LogType.APPOINTMENT_MESSAGE_ALL);
        this.allReminderOpen = false;
      }
    } else {
      this.notificationService.show({
        content: 'Canceled',
        animation: { type: 'slide', duration: 500 },
        position: { horizontal: 'center', vertical: 'bottom' },
        type: { style: 'error', icon: true },
        hideAfter: 2000
      });
      this.allReminderOpen = false;
    }
  }

  public selectedAllMessageChange(picker) {
    if (picker !== undefined) {
      this.allMessage = picker;
    }
  }

  isUpdateButtonDisabled(): boolean {
    return !this.statusChangeText.trim(); // Disable if the text is empty or contains only whitespace
  }

  getDateFormatted() {
    if (this.appointment.appointment_date != null) {
      this.date = moment(this.appointment.appointment_date).format('D MMM YYYY');
      this.time = moment(this.appointment.appointment_date).format('LT');
      return `${this.date} | ${this.time}`
    } else {
      return `TO BE DETERMINED`
    }
  }

  formatDate(date) {
    if (date != null) {
      this.date = moment(date).format('D MMM YYYY');
      this.time = moment(date).format('LT');
      return `${this.date} | ${this.time}`
    } else {
      return `NOT JOINED`
    }
  }

  getCreatedAt() {
    if (this.appointment.created_at != null) {
      return utils.getCreatedAt(this.appointment.created_at)
    } else {
      return `Unknown`
    }
  }

  getUpdatedAt() {
    if (this.appointment.updated_at != null) {
      return utils.getUpdatedAt(this.appointment.updated_at)
    } else {
      return `Unknown`
    }
  }

  selectDate(date, index) {
    this.router.navigate(['/admin/update-time', date, this.appointment.expert_id]);
    // this.router.navigate(['/admin/confirm-time', date]);
  }

  sortWeek() {
    const totalDays = 14;

    for (let i = 0; i < totalDays; i++) {
      const currentDate = moment().add(i, 'day').format('ddd, MMMM DD');
      this.days.push(currentDate);
    }
    this.daysLoaded = true;
  }

  public selectedChange(e: boolean, selected: boolean): void {
    this.receivedRequestedInfoSelected = selected;
  }

  getRequestedTime() {
    return moment(this.appointment.appointment_date).format('DD MMMM YYYY | LT').toString();
  }

  public setFormValues() {
    this.specialtyFormGroup = new UntypedFormGroup({
      specialty: new UntypedFormControl(null, [Validators.required]),
      subSpecialty: new UntypedFormControl(null, [])
    });

    this.adminResolutionNoteFormGroup = new UntypedFormGroup({
      admin_resolution_notes: new UntypedFormControl(null, [Validators.required]),
    });

    this.adminNoteFormGroup = new UntypedFormGroup({
      admin_note: new UntypedFormControl(null, [Validators.required]),
    });

    this.submitRequestForm = new UntypedFormGroup({
      requestText: new UntypedFormControl(null, [Validators.required]),
    });
  }

  handleRequest() {
    if (this.submitRequestForm.valid) {
      const submitvalue = this.submitRequestForm.value.requestText;
      if (this.appointment.expert_request == null) {
        this.appointment.expert_request = [];
        this.appointment.expert_request[0] = submitvalue;
      } else {
        this.appointment.expert_request[0] = submitvalue;
      }
      this.requestAdditionalInfo(this.appointment);
    }
  }

  public requestAdditionalInfo(appointment: Appointment): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      resolve(this.appointmentCollectionService.requestAdditionalInfo(appointment));
    }).then((savedAppointment) => {
      if (savedAppointment != null && savedAppointment.id != null) {
        const convertedTimestamp = moment(savedAppointment.appointment_date_timestamp, 'x').format('MMM D LT');

        const emailMessage = savedAppointment.appointment_date_timestamp != null && convertedTimestamp != null
          ? `${savedAppointment.expert_first_name} ${savedAppointment.expert_last_name} requested additional information for your ${convertedTimestamp} consult. Please submit additional information and resubmit your consult request.`
          : `${savedAppointment.expert_first_name} ${savedAppointment.expert_last_name} requested additional information for your consult. Please submit additional information and resubmit your consult request.`;

        this.emailNotificationService.sendEmailAndPush(
          UserTypeEnum.DOCTOR,
          appointment.doctor_id,
          'WTD - Information Requested To Confirm Consult',
          emailMessage,
          NotificationType.APPOINTMENT_GENERAL,
          appointment.id
        );

        this.notificationService.show({
          content: 'Requested Additional Information',
          animation: { type: 'slide', duration: 500 },
          position: { horizontal: 'center', vertical: 'bottom' },
          type: { style: 'success', icon: true },
          hideAfter: 2000
        });
      } else {
        this.notificationService.show({
          content: 'Error requesting additional information.',
          animation: { type: 'slide', duration: 500 },
          position: { horizontal: 'center', vertical: 'bottom' },
          type: { style: 'error', icon: true },
          hideAfter: 2000
        });
      }
    });
  }

  confirmAppointment() {
    if (this.appointment.expert_request != null && this.appointment.expert_request.length > 0 && this.receivedRequestedInfoSelected == null) {
      this.confirmAppointmentError = true;
      return;
    }
    this.confirmAppointmentError = false;

    this.appointment.received_requested_info = this.receivedRequestedInfoSelected;

    const submitvalue = this.submitRequestForm.value.requestText;
    if (submitvalue != null && submitvalue != '') {
      if (this.appointment.expert_request == null) {
        this.appointment.expert_request = [];
        this.appointment.expert_request[0] = submitvalue;
      } else {
        this.appointment.expert_request[0] = submitvalue;
      }
    }
    this.createZoomMeeting();
  }

  public createZoomMeeting(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      resolve(this.expertService.createZoomMeeting(this.appointment));
    }).then((zoomMeeting) => {
      if (zoomMeeting != null && zoomMeeting.start_url != null) {
        if (!this.appointment.urgent) {
          this.appointment.confirmed = true;
        } else {
          this.appointment.urgent_confirmed = true;
        }
        this.appointment.info_requested = false;
        this.appointment.zoom_start = zoomMeeting.start_url;
        this.appointment.zoom_join = zoomMeeting.join_url;

        this.saveAppointment();
      } else {
        this.notificationService.show({
          content: 'Error creating zoom meeting.',
          animation: { type: 'slide', duration: 500 },
          position: { horizontal: 'center', vertical: 'bottom' },
          type: { style: 'error', icon: true },
          hideAfter: 2000
        });
      }
    });
  }

  public saveAppointment(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      resolve(this.appointmentCollectionService.confirmAppointmentRequest(this.appointment));
    }).then((appointment) => {
      if (appointment != null) {
        if (this.appointment.urgent) {
          this.notificationService.show({
            content: 'Time Requested',
            animation: { type: 'slide', duration: 500 },
            position: { horizontal: 'center', vertical: 'bottom' },
            type: { style: 'success', icon: true },
            hideAfter: 2000
          });
        } else {
          this.notificationService.show({
            content: 'Appointment Confirmed',
            animation: { type: 'slide', duration: 500 },
            position: { horizontal: 'center', vertical: 'bottom' },
            type: { style: 'success', icon: true },
            hideAfter: 2000
          });
        }
      } else {
        this.notificationService.show({
          content: 'Error saving appointment',
          animation: { type: 'slide', duration: 500 },
          position: { horizontal: 'center', vertical: 'bottom' },
          type: { style: 'error', icon: true },
          hideAfter: 2000
        });
      }
    });
  }

  public updateSubSpecialtyList(index: number) {
    const newSubSpecialityList: SubSpecialty[] = [];
    for (let i = 0; i < this.subSpecialtyListArray.length; i++) {
      if (this.subSpecialtyListArray[i].specialty_id == this.specialtyArray[index].id) {
        newSubSpecialityList.push(this.subSpecialtyListArray[i]);
      } else if (index == 0) {
        newSubSpecialityList.push(this.subSpecialtyListArray[i]);
      }
    }

    this.subSpecialtyMain = newSubSpecialityList;
    this.selectedSubSpecialties = this.subSpecialtyMain[0];
    this.isSubSpecialtyLoaded = true;

    const appointmentSpecialtyValue: Specialty[] = this.specialtyArray.filter(
      (s) => {
        if (this.appointment != null) {
          s.id === this.appointment.specialty.id
        }
      }
    );
    this.specialtyFormGroup.get('specialty').setValue(appointmentSpecialtyValue[0]);
    this.setInitialIndex(appointmentSpecialtyValue[0])
  }

  relevantLabTap(lab) {
    this.router.navigate(['/relevant-lab', lab.id]);
  }

  handleJoin() {
    if (this.appointment.zoom_join) {
      window.open(this.appointment.zoom_join, "_blank");
    }
  }

  handleStart() {
    if (this.appointment.zoom_start) {
      window.open(this.appointment.zoom_start, "_blank");
    }
  }

  handleExpertSearch() {
    this.updateTime = false;
    if (this.expertListLoaded) {
      this.expertListLoaded = false;
    }
    this.searchExperts = !this.searchExperts;
  }

  handleDoctorSearch() {
    this.updateTime = false;
    this.searchDoctors = !this.searchDoctors;
    if (this.expertListLoaded) {
      this.expertListLoaded = false;
    } else {
      this.searchExperts = !this.searchExperts;
    }
  }

  setInitialIndex(specialty) {
    if (specialty === undefined) {
      this.dataResultsSubSpecialties = [];
      this.isDisabledSubSpecialties = false;
      const specialty = this.specialtyArray.filter(
        (s) => s.id === this.appointment.specialty.id
      );
      this.dataResultsSubSpecialties = this.subSpecialtyListArray.filter(
        (s) => s.specialty_id === this.appointment.specialty.id
      );
      const appointmentSubSpecialtyValue: Specialty[] = this.subSpecialtyListArray.filter(
        (s) => s.id === this.appointment.sub_specialty.id
      );
      this.specialtyFormGroup.get('specialty').setValue(specialty[0]);
      this.specialtyFormGroup.get('subSpecialty').setValue(appointmentSubSpecialtyValue[0]);
    } else {
      this.dataResultsSubSpecialties = [];
      this.isDisabledSubSpecialties = false;
      this.dataResultsSubSpecialties = this.subSpecialtyListArray.filter(
        (s) => s.specialty_id === specialty.id
      );
      const appointmentSubSpecialtyValue: Specialty[] = this.subSpecialtyListArray.filter(
        (s) => s.id === this.appointment.sub_specialty.id
      );
      this.specialtyFormGroup.get('subSpecialty').setValue(appointmentSubSpecialtyValue[0]);
    }
  }

  public selectedLocationMessageChange(picker) {
    if (picker !== undefined) {
      this.locationMessage = picker;
    }
  }

  public selectedExpertMessageChange(picker) {
    if (picker !== undefined) {
      this.expertMessage = picker;
    }
  }

  public selectedDoctorMessageChange(picker) {
    if (picker !== undefined) {
      this.doctorMessage = picker;
    }
  }

  public selectedIndexChanged(picker) {
    if (picker === undefined) {
      this.isDisabledSubSpecialties = true;
      this.dataResultsSubSpecialties = [];
      this.isSearchAvailable = false;
    } else {
      this.dataResultsSubSpecialties = [];
      this.specialtyFormGroup.get('subSpecialty').setValue(null);
      this.isDisabledSubSpecialties = false;
      if (picker.id === '0') {
        this.dataResultsSubSpecialties = this.subSpecialtyListArray;
      } else {
        this.dataResultsSubSpecialties = this.subSpecialtyListArray.filter(
          (s) => s.specialty_id === picker.id
        );
      }
      this.isSearchAvailable = true;
      this.specialtyFormGroup.get('subSpecialty').setValue(this.dataResultsSubSpecialties[0]);
    }
  }

  public selectedSubIndexChanged(picker2) {
    this.selectedSubSpecialties = this.subSpecialtyMain[picker2.selectedIndex];
  }

  public hanndleSearch(): void {
    this.specialtyFormGroup.markAllAsTouched();
    const formValues = this.specialtyFormGroup.value;
    if (formValues.specialty != null) {
      this.expertService.getExpertIDsBySpecialties(formValues.specialty, formValues.subSpecialty);
      this.searchExperts = false;
      this.expertListLoaded = true;
    } else {
      this.formErrorOpen = true;
    }
  }

  handleSubmitAdminResolution() {
    this.adminResolutionNoteFormGroup.markAllAsTouched();
    const formValues = this.adminResolutionNoteFormGroup.value;
    if (this.adminResolutionNoteFormGroup.valid) {
      this.appointment.expectation_resolved = true;
      this.appointment.admin_resolution_notes = formValues.admin_resolution_notes
      this.appointmentCollectionService.updateAppointmentAsync(this.appointment);
    }
  }

  handleSubmitAdminNote() {
    this.adminNoteFormGroup.markAllAsTouched();
    const formValues = this.adminNoteFormGroup.value;
    if (this.adminNoteFormGroup.valid) {
      const adminNote = formValues.admin_note;
      this.adminNoteFormGroup.reset();
      this.adminNotesService.createAdminNote(this.appointment.id, adminNote);
    }

  }

  public cancelChanges(): void {
    this.setFormValues();
    this.handleExpertSearch();
  }

  closeSearchExpert() {
    this.searchExperts = false;
    this.expertListLoaded = false;
    this.updateTime = false
  }

  handleGoBackToSearchExpert() {
    this.searchExperts = true;
    this.expertListLoaded = false;
    this.updateTime = false
  }

  handleInviteExpert(expert) {
    let found = null;
    if (this.appointment.experts_invited != null && this.appointment.experts_invited.length > 0) {
      found = this.appointment.experts_invited.find(exp => exp.id == expert.id);
    }
    if (!found) {
      if (expert.email != null && expert.email != '') {
        // Email and Push EXPERT
        this.emailNotificationService.sendEmailAndPush(
          UserTypeEnum.EXPERT,
          expert.id,
          'WTD - Need Coverage',
          'Please reply if you are available for coverage.',
          NotificationType.APPOINTMENT_GENERAL,
          this.appointment.id
        )
      }
      this.appointment.session_invites_sent = true;

      this.appointment.experts_invited.push(this.expert);

      this.appointmentCollectionService.resubmitAppointment(this.appointment);
      this.logService.createAppointmentLog(this.appointment.id, LogType.INVITE_EXPERT);

      this.notificationService.show({
        content: 'Invitation sent.',
        animation: { type: 'slide', duration: 500 },
        position: { horizontal: 'center', vertical: 'bottom' },
        type: { style: 'success', icon: true },
        hideAfter: 2000
      });
    } else {
      this.notificationService.show({
        content: 'Already invited.',
        animation: { type: 'slide', duration: 500 },
        position: { horizontal: 'center', vertical: 'bottom' },
        type: { style: 'error', icon: true },
        hideAfter: 2000
      });
    }

  }

  handleInviteAllInSession() {
    // Email and Push DOCTOR
    this.emailNotificationService.sendEmailAndPush(
      UserTypeEnum.DOCTOR,
      this.doctor.id,
      'WTD - Reminder',
      utils.getSendReminderAll(),
      NotificationType.APPOINTMENT_GENERAL,
      this.appointment.id
    )

    // Email and Push EXPERT
    this.emailNotificationService.sendEmailAndPush(
      UserTypeEnum.EXPERT,
      this.expert.id,
      'WTD - Reminder',
      utils.getSendReminderAll(),
      NotificationType.APPOINTMENT_GENERAL,
      this.appointment.id
    )

    // Email LOCATION
    this.emailNotificationService.sendEmail(
      'WTD - Reminder',
      this.orgLocation.email,
      utils.getSendReminderAll(),
      `${this.orgLocation.location_name}`
    );

    this.notificationService.show({
      content: 'Reminder sent.',
      animation: { type: 'slide', duration: 500 },
      position: { horizontal: 'center', vertical: 'bottom' },
      type: { style: 'success', icon: true },
      hideAfter: 2000
    });
  }

  handleInviteAll() {
    this.experts.forEach(expert => {
      if (expert.email != null && expert.email != '') {
        // Email and Push EXPERT
        this.emailNotificationService.sendEmailAndPush(
          UserTypeEnum.EXPERT,
          expert.id,
          'WTD - Need Coverage',
          'Please reply if you are available for coverage.',
          NotificationType.APPOINTMENT_GENERAL,
          this.appointment.id
        )
      }
    });
    this.appointment.session_invites_sent = true;
    this.appointment.experts_invited = this.experts;

    this.appointmentCollectionService.resubmitAppointment(this.appointment);
    this.logService.createAppointmentLog(this.appointment.id, LogType.INVITE_MULTIPLE_EXPERT);

    this.notificationService.show({
      content: 'Invitations sent.',
      animation: { type: 'slide', duration: 500 },
      position: { horizontal: 'center', vertical: 'bottom' },
      type: { style: 'success', icon: true },
      hideAfter: 2000
    });
  }

  handleReplaceExpert(expert) {
    this.replacementExpert = expert;
    this.replaceExpertOpen = true;
  }

  public closeLocationReminder(status) {
    if (status === 'yes') {
      if (this.locationMessage === '' || this.locationMessage == null) {
        this.notificationService.show({
          content: 'Please add message',
          animation: { type: 'slide', duration: 500 },
          position: { horizontal: 'center', vertical: 'bottom' },
          type: { style: 'error', icon: true },
          hideAfter: 2000
        });
      } else {
        // Email LOCATION
        this.emailNotificationService.sendEmail(
          'WTD - Reminder',
          this.orgLocation.email,
          this.locationMessage,
          `${this.orgLocation.location_name}`
        );

        this.notificationService.show({
          content: 'Sent message to location.',
          animation: { type: 'slide', duration: 500 },
          position: { horizontal: 'center', vertical: 'bottom' },
          type: { style: 'success', icon: true },
          hideAfter: 2000
        });

        this.appointmentCollectionService.submitLocationMessage(this.appointment.id, this.locationMessage);

        this.logService.createAppointmentLog(this.appointment.id, LogType.LOCATION_REMINDER);
        this.locationReminderOpen = false;
      }
    } else {
      this.notificationService.show({
        content: 'Canceled',
        animation: { type: 'slide', duration: 500 },
        position: { horizontal: 'center', vertical: 'bottom' },
        type: { style: 'error', icon: true },
        hideAfter: 2000
      });
      this.locationReminderOpen = false;
    }
  }

  public closeExpertReminder(status) {
    if (status === 'yes') {
      if (this.expertMessage === '' || this.expertMessage == null) {
        this.notificationService.show({
          content: 'Please add message',
          animation: { type: 'slide', duration: 500 },
          position: { horizontal: 'center', vertical: 'bottom' },
          type: { style: 'error', icon: true },
          hideAfter: 2000
        });
      } else {
        // Email and Push EXPERT
        this.emailNotificationService.sendEmailAndPush(
          UserTypeEnum.EXPERT,
          this.expert.id,
          'WTD - Message',
          this.expertMessage,
          NotificationType.APPOINTMENT_GENERAL,
          this.appointment.id
        ).catch(err => {
          console.log(err);
        });

        this.notificationService.show({
          content: 'Sent message to expert.',
          animation: { type: 'slide', duration: 500 },
          position: { horizontal: 'center', vertical: 'bottom' },
          type: { style: 'success', icon: true },
          hideAfter: 2000
        });

        this.appointmentCollectionService.submitExpertMessage(this.appointment.id, this.expertMessage);
        this.logService.createAppointmentLog(this.appointment.id, LogType.EXPERT_REMINDER);
        this.expertReminderOpen = false;
      }
    } else {
      this.notificationService.show({
        content: 'Canceled',
        animation: { type: 'slide', duration: 500 },
        position: { horizontal: 'center', vertical: 'bottom' },
        type: { style: 'error', icon: true },
        hideAfter: 2000
      });
      this.expertReminderOpen = false;
    }
  }

  public closeDoctorReminder(status) {
    if (status === 'yes') {
      if (this.doctorMessage === '' || this.doctorMessage == null) {
        this.notificationService.show({
          content: 'Please add message',
          animation: { type: 'slide', duration: 500 },
          position: { horizontal: 'center', vertical: 'bottom' },
          type: { style: 'error', icon: true },
          hideAfter: 2000
        });
      } else {
        // // Email and Push DOCTOR
        this.emailNotificationService.sendEmailAndPush(
          UserTypeEnum.DOCTOR,
          this.doctor.id,
          'WTD - Message',
          this.doctorMessage,
          NotificationType.APPOINTMENT_GENERAL,
          this.appointment.id
        )

        this.notificationService.show({
          content: 'Sent message to doctor.',
          animation: { type: 'slide', duration: 500 },
          position: { horizontal: 'center', vertical: 'bottom' },
          type: { style: 'success', icon: true },
          hideAfter: 2000
        });

        this.appointmentCollectionService.submitDoctorMessage(this.appointment.id, this.doctorMessage);
        this.logService.createAppointmentLog(this.appointment.id, LogType.DOCTOR_REMINDER);
        this.doctorReminderOpen = false;
      }
    } else {
      this.notificationService.show({
        content: 'Canceled',
        animation: { type: 'slide', duration: 500 },
        position: { horizontal: 'center', vertical: 'bottom' },
        type: { style: 'error', icon: true },
        hideAfter: 2000
      });
      this.doctorReminderOpen = false;
    }
  }

  public closeReplaceExpert(status) {
    if (status === 'yes') {
      // Email and Push EXPERT being replaced
      this.emailNotificationService.sendEmailAndPush(
        UserTypeEnum.EXPERT,
        this.expert.id,
        'WTD - Coverage Update',
        utils.getReplacedExpertMessage(),
        NotificationType.APPOINTMENT_GENERAL,
        this.appointment.id
      )

      // Email and Push replacement EXPERT
      this.emailNotificationService.sendEmailAndPush(
        UserTypeEnum.EXPERT,
        this.replacementExpert.id,
        'WTD - Coverage Update',
        utils.getReplacementExpertMessage(),
        NotificationType.APPOINTMENT_GENERAL,
        this.appointment.id
      )

      this.appointment.expert_id = this.replacementExpert.id;
      this.appointment.expert_first_name = this.replacementExpert.first_name;
      this.appointment.expert_last_name = this.replacementExpert.last_name;

      this.appointmentCollectionService.resubmitAppointment(this.appointment);
      this.logService.createAppointmentLog(this.appointment.id, LogType.EXPERT_REPLACED);

      this.notificationService.show({
        content: 'Expert replaced, emails sent.',
        animation: { type: 'slide', duration: 500 },
        position: { horizontal: 'center', vertical: 'bottom' },
        type: { style: 'success', icon: true },
        hideAfter: 2000
      });
      this.replaceExpertOpen = false;
      this.closeSearchExpert();
    } else {
      this.notificationService.show({
        content: 'Canceled',
        animation: { type: 'slide', duration: 500 },
        position: { horizontal: 'center', vertical: 'bottom' },
        type: { style: 'error', icon: true },
        hideAfter: 2000
      });
      this.replaceExpertOpen = false;
    }
  }

  public closeCoverageNotice(status) {
    if (status === 'yes') {
      this.appointment.experts_invited.forEach(expert => {
        // Email and Push EXPERT
        this.emailNotificationService.sendEmailAndPush(
          UserTypeEnum.EXPERT,
          expert.id,
          'WTD - Coverage Found',
          'Coverage has been found.',
          NotificationType.APPOINTMENT_GENERAL,
          this.appointment.id
        )
      })

      this.appointment.session_invites_sent = false;
      this.appointment.experts_invited = [];

      this.appointmentCollectionService.resubmitAppointment(this.appointment);
      this.logService.createAppointmentLog(this.appointment.id, LogType.CANCEL_COVERAGE_NOTICE);

      this.notificationService.show({
        content: 'Email sent.',
        animation: { type: 'slide', duration: 500 },
        position: { horizontal: 'center', vertical: 'bottom' },
        type: { style: 'success', icon: true },
        hideAfter: 2000
      });
    } else {
      this.notificationService.show({
        content: 'Canceled',
        animation: { type: 'slide', duration: 500 },
        position: { horizontal: 'center', vertical: 'bottom' },
        type: { style: 'error', icon: true },
        hideAfter: 2000
      });
    }
    this.expertFoundOpened = false;
  }

  public closeCIMAMessageSelection(status) {
    if (status === 'yes') {
      if (this.selectedAllOption === 'In App / Push Message') {
        // Email ALL
        this.emailNotificationService.sendMultipleEmails(
          'WTD - Message',
          [this.orgLocation.email, this.doctor.email, this.expert.email],
          this.allMessage,
          `${this.orgLocation.location_name}`
        );

        // Email and Push DOCTOR
        this.emailNotificationService.sendPushNotificationOnly(
          UserTypeEnum.DOCTOR,
          this.doctor.id,
          'WTD - Message',
          this.allMessage,
          NotificationType.APPOINTMENT_GENERAL,
          this.appointment.id
        )

        // Email and Push EXPERT
        this.emailNotificationService.sendPushNotificationOnly(
          UserTypeEnum.EXPERT,
          this.expert.id,
          'WTD - Message',
          this.allMessage,
          NotificationType.APPOINTMENT_GENERAL,
          this.appointment.id
        )

        this.notificationService.show({
          content: 'Sent messages.',
          animation: { type: 'slide', duration: 500 },
          position: { horizontal: 'center', vertical: 'bottom' },
          type: { style: 'success', icon: true },
          hideAfter: 2000
        });

        this.appointmentCollectionService.submitExpertMessage(this.appointment.id, this.allMessage);
        this.appointmentCollectionService.submitDoctorMessage(this.appointment.id, this.allMessage);
        this.logService.createAppointmentLog(this.appointment.id, LogType.APPOINTMENT_MESSAGE_ALL);
        this.cimaSelectionoOpen = false;
      } else {

        // CIMA expert
        if (this.expert && this.expert.phone) {
          // is valid phone number
          const phoneValidation = phone(this.expert.phone, { country: '' });
          if (!phoneValidation.isValid) {
            this.notificationService.show({
              content: 'Not a valid phone number for expert.',
              animation: { type: 'slide', duration: 500 },
              position: { horizontal: 'center', vertical: 'bottom' },
              type: { style: 'error', icon: true },
              hideAfter: 5000
            });
          } else {
            // capitalize first letter of the names
            const doctorInfo = this.doctor ? `${this.doctor.first_name.charAt(0).toUpperCase() + this.doctor.first_name.slice(1)} ${this.doctor.last_name.charAt(0).toUpperCase() + this.doctor.last_name.slice(1)}` : 'Doctor';

            // get appointment date and time, convert to the experts timezone and format, for example: May 5th, 2021 at 3:00 PM PST
            const appointmentDateformatted = moment(this.appointment.appointment_date).tz(this.expert?.timezone?.value).format('MMMM Do, YYYY');

            const appointmentTimeformatted = moment(this.appointment.appointment_date).tz(this.expert?.timezone?.value).format('h:mm A z');

            const appointmentInfo = `Appointment: ${appointmentDateformatted} at ${appointmentTimeformatted} with ${doctorInfo}`;


            this.emailNotificationService.sendCIMANotification(this.expert, phoneValidation.phoneNumber, this.allMessage + ' - ' + appointmentInfo);
            // this.appointmentCollectionService.submitExpertMessage(this.appointment.id, this.expertMessage);

            this.logService.createAppointmentLog(this.appointment.id, LogType.EXPERT_REMINDER_CIMA);

            this.notificationService.show({
              content: 'Sent message to expert.',
              animation: { type: 'slide', duration: 500 },
              position: { horizontal: 'center', vertical: 'bottom' },
              type: { style: 'success', icon: true },
              hideAfter: 2000
            });
          }
        } else {
          this.notificationService.show({
            content: 'Not a valid phone number for Expert.',
            animation: { type: 'slide', duration: 500 },
            position: { horizontal: 'center', vertical: 'bottom' },
            type: { style: 'error', icon: true },
            hideAfter: 5000
          });
        }

        // CIMA location
        if (this.orgLocation && this.orgLocation.phone) {
          // is valid phone number
          const phoneValidation = phone(this.orgLocation.phone, { country: '' });
          if (!phoneValidation.isValid) {
            this.notificationService.show({
              content: 'Not a valid phone number for Location.',
              animation: { type: 'slide', duration: 500 },
              position: { horizontal: 'center', vertical: 'bottom' },
              type: { style: 'error', icon: true },
              hideAfter: 5000
            });
          } else {
            // capitalize first letter of the names
            const expertInfo = this.expert ? `${this.expert.first_name.charAt(0).toUpperCase() + this.expert.first_name.slice(1)} ${this.expert.last_name.charAt(0).toUpperCase() + this.expert.last_name.slice(1)}` : 'Expert';

            // doctor info
            const doctorInfo = this.doctor ? `${this.doctor.first_name.charAt(0).toUpperCase() + this.doctor.first_name.slice(1)} ${this.doctor.last_name.charAt(0).toUpperCase() + this.doctor.last_name.slice(1)}` : 'Doctor';

            // get appointment date and time, convert to the experts timezone and format, for example: May 5th, 2021 at 3:00 PM PST
            const appointmentDateformatted = moment(this.appointment.appointment_date).tz(this.orgLocation?.timezone?.value).format('MMMM Do, YYYY');

            const appointmentTimeformatted = moment(this.appointment.appointment_date).tz(this.orgLocation?.timezone?.value).format('h:mm A z');

            const appointmentInfo = `Appointment: ${appointmentDateformatted} at ${appointmentTimeformatted} with Expert: ${expertInfo} and Doctor: ${doctorInfo}`;

            this.emailNotificationService.sendCIMALocationNotification(this.orgLocation, phoneValidation.phoneNumber, this.allMessage + ' - ' + appointmentInfo);
            // this.appointmentCollectionService.submitLocationMessage(this.appointment.id, this.locationMessage);
            this.logService.createAppointmentLog(this.appointment.id, LogType.LOCATION_REMINDER_CIMA);

            this.notificationService.show({
              content: 'Sent message to location.',
              animation: { type: 'slide', duration: 500 },
              position: { horizontal: 'center', vertical: 'bottom' },
              type: { style: 'success', icon: true },
              hideAfter: 2000
            });
          }
        } else {
          this.notificationService.show({
            content: 'Not a valid phone number for Location.',
            animation: { type: 'slide', duration: 500 },
            position: { horizontal: 'center', vertical: 'bottom' },
            type: { style: 'error', icon: true },
            hideAfter: 5000
          });
        }

        // CIMA doctor
        if (this.doctor && this.doctor.phone) {
          // is valid phone number
          const phoneValidation = phone(this.doctor.phone, { country: '' });
          if (!phoneValidation.isValid) {
            this.notificationService.show({
              content: 'Not a valid phone number for Doctor.',
              animation: { type: 'slide', duration: 500 },
              position: { horizontal: 'center', vertical: 'bottom' },
              type: { style: 'error', icon: true },
              hideAfter: 5000
            });
          } else {

            // capitalize first letter of the names
            const expertInfo = this.expert ? `${this.expert.first_name.charAt(0).toUpperCase() + this.expert.first_name.slice(1)} ${this.expert.last_name.charAt(0).toUpperCase() + this.expert.last_name.slice(1)}` : 'Expert';

            // get appointment date and time, convert to the experts timezone and format, for example: May 5th, 2021 at 3:00 PM PST
            const appointmentDateformatted = moment(this.appointment.appointment_date).tz(this.orgLocation?.timezone?.value).format('MMMM Do, YYYY');

            const appointmentTimeformatted = moment(this.appointment.appointment_date).tz(this.orgLocation?.timezone?.value).format('h:mm A z');

            const appointmentInfo = `Appointment: ${appointmentDateformatted} at ${appointmentTimeformatted} with ${expertInfo}`;

            this.emailNotificationService.sendCIMANotification(this.doctor, phoneValidation.phoneNumber, this.allMessage + ' - ' + appointmentInfo);
            // this.appointmentCollectionService.submitDoctorMessage(this.appointment.id, this.doctorMessage);
            this.logService.createAppointmentLog(this.appointment.id, LogType.DOCTOR_REMINDER_CIMA);

            this.notificationService.show({
              content: 'Sent message to doctor.',
              animation: { type: 'slide', duration: 500 },
              position: { horizontal: 'center', vertical: 'bottom' },
              type: { style: 'success', icon: true },
              hideAfter: 2000
            });
          }
        } else {
          this.notificationService.show({
            content: 'Not a valid phone number for Doctor.',
            animation: { type: 'slide', duration: 500 },
            position: { horizontal: 'center', vertical: 'bottom' },
            type: { style: 'error', icon: true },
            hideAfter: 5000
          });
        }
      }

      this.cimaSelectionoOpen = false;
    } else {
      this.notificationService.show({
        content: 'Canceled',
        animation: { type: 'slide', duration: 500 },
        position: { horizontal: 'center', vertical: 'bottom' },
        type: { style: 'error', icon: true },
        hideAfter: 2000
      });
      this.cimaSelectionoOpen = false;
    }
  }

  public closeCIMAExpertMessageSelection(status) {
    if (status === 'yes') {
      if (this.selectedExpertOption === 'In App / Push Message') {
        // Email EXPERT
        this.emailNotificationService.sendEmail(
          'WTD - Message',
          this.expert.email,
          this.expertMessage,
          `${this.expert.first_name} ${this.expert.last_name}`
        );

        this.notificationService.show({
          content: 'Sent message to expert.',
          animation: { type: 'slide', duration: 500 },
          position: { horizontal: 'center', vertical: 'bottom' },
          type: { style: 'success', icon: true },
          hideAfter: 2000
        });

        this.appointmentCollectionService.submitExpertMessage(this.appointment.id, this.expertMessage);
        this.logService.createAppointmentLog(this.appointment.id, LogType.EXPERT_REMINDER);
      } else {
        if (this.expert && this.expert.phone) {
          // is valid phone number
          const phoneValidation = phone(this.expert.phone, { country: '' });
          if (!phoneValidation.isValid) {
            this.notificationService.show({
              content: 'Not a valid phone number.',
              animation: { type: 'slide', duration: 500 },
              position: { horizontal: 'center', vertical: 'bottom' },
              type: { style: 'error', icon: true },
              hideAfter: 5000
            });
            return;
          } else {
            // capitalize first letter of the names
            const doctorInfo = this.doctor ? `${this.doctor.first_name.charAt(0).toUpperCase() + this.doctor.first_name.slice(1)} ${this.doctor.last_name.charAt(0).toUpperCase() + this.doctor.last_name.slice(1)}` : 'Doctor';

            // get appointment date and time, convert to the experts timezone and format, for example: May 5th, 2021 at 3:00 PM PST
            const appointmentDateformatted = moment(this.appointment.appointment_date).tz(this.expert?.timezone?.value).format('MMMM Do, YYYY');

            const appointmentTimeformatted = moment(this.appointment.appointment_date).tz(this.expert?.timezone?.value).format('h:mm A z');

            const appointmentInfo = `Appointment: ${appointmentDateformatted} at ${appointmentTimeformatted} with ${doctorInfo}`;

            this.emailNotificationService.sendCIMANotification(this.expert, phoneValidation.phoneNumber, this.expertMessage + ' - ' + appointmentInfo);
            // this.appointmentCollectionService.submitExpertMessage(this.appointment.id, this.expertMessage);
            this.logService.createAppointmentLog(this.appointment.id, LogType.EXPERT_REMINDER_CIMA);

            this.notificationService.show({
              content: 'Sent message to expert.',
              animation: { type: 'slide', duration: 500 },
              position: { horizontal: 'center', vertical: 'bottom' },
              type: { style: 'success', icon: true },
              hideAfter: 2000
            });
          }
        } else {
          this.notificationService.show({
            content: 'Not a valid phone number.',
            animation: { type: 'slide', duration: 500 },
            position: { horizontal: 'center', vertical: 'bottom' },
            type: { style: 'error', icon: true },
            hideAfter: 5000
          });
          return;
        }
      }

      this.cimaExpertSelectionoOpen = false;
    } else {
      this.notificationService.show({
        content: 'Canceled',
        animation: { type: 'slide', duration: 500 },
        position: { horizontal: 'center', vertical: 'bottom' },
        type: { style: 'error', icon: true },
        hideAfter: 2000
      });
      this.cimaExpertSelectionoOpen = false;
    }
  }

  public closeCIMALocationMessageSelection(status) {
    if (status === 'yes') {
      if (this.selectedLocationOption === 'In App / Push Message') {
        // Email LOCATION
        this.emailNotificationService.sendEmail(
          'WTD - Message',
          this.orgLocation.email,
          this.locationMessage,
          `${this.orgLocation.location_name}`
        );

        this.notificationService.show({
          content: 'Sent message to location.',
          animation: { type: 'slide', duration: 500 },
          position: { horizontal: 'center', vertical: 'bottom' },
          type: { style: 'success', icon: true },
          hideAfter: 2000
        });

        this.appointmentCollectionService.submitLocationMessage(this.appointment.id, this.locationMessage);
        this.logService.createAppointmentLog(this.appointment.id, LogType.LOCATION_REMINDER);
      } else {
        if (this.orgLocation && this.orgLocation.phone) {
          // is valid phone number
          const phoneValidation = phone(this.orgLocation.phone, { country: '' });
          if (!phoneValidation.isValid) {
            this.notificationService.show({
              content: 'Not a valid phone number.',
              animation: { type: 'slide', duration: 500 },
              position: { horizontal: 'center', vertical: 'bottom' },
              type: { style: 'error', icon: true },
              hideAfter: 5000
            });
            return;
          } else {
            // capitalize first letter of the names
            const expertInfo = this.expert ? `${this.expert.first_name.charAt(0).toUpperCase() + this.expert.first_name.slice(1)} ${this.expert.last_name.charAt(0).toUpperCase() + this.expert.last_name.slice(1)}` : 'Expert';

            // doctor info
            const doctorInfo = this.doctor ? `${this.doctor.first_name.charAt(0).toUpperCase() + this.doctor.first_name.slice(1)} ${this.doctor.last_name.charAt(0).toUpperCase() + this.doctor.last_name.slice(1)}` : 'Doctor';

            // get appointment date and time, convert to the experts timezone and format, for example: May 5th, 2021 at 3:00 PM PST
            const appointmentDateformatted = moment(this.appointment.appointment_date).tz(this.orgLocation?.timezone?.value).format('MMMM Do, YYYY');

            const appointmentTimeformatted = moment(this.appointment.appointment_date).tz(this.orgLocation?.timezone?.value).format('h:mm A z');

            const appointmentInfo = `Appointment: ${appointmentDateformatted} at ${appointmentTimeformatted} with Expert: ${expertInfo} and Doctor: ${doctorInfo}`;

            this.emailNotificationService.sendCIMALocationNotification(this.orgLocation, phoneValidation.phoneNumber, this.locationMessage + ' - ' + appointmentInfo);
            // this.appointmentCollectionService.submitLocationMessage(this.appointment.id, this.locationMessage);
            this.logService.createAppointmentLog(this.appointment.id, LogType.LOCATION_REMINDER_CIMA);

            this.notificationService.show({
              content: 'Sent message to location.',
              animation: { type: 'slide', duration: 500 },
              position: { horizontal: 'center', vertical: 'bottom' },
              type: { style: 'success', icon: true },
              hideAfter: 2000
            });
          }
        } else {
          this.notificationService.show({
            content: 'Not a valid phone number.',
            animation: { type: 'slide', duration: 500 },
            position: { horizontal: 'center', vertical: 'bottom' },
            type: { style: 'error', icon: true },
            hideAfter: 5000
          });
          return;
        }
      }

      this.cimaLocationSelectionoOpen = false;

    } else {
      this.notificationService.show({
        content: 'Canceled',
        animation: { type: 'slide', duration: 500 },
        position: { horizontal: 'center', vertical: 'bottom' },
        type: { style: 'error', icon: true },
        hideAfter: 2000
      });
      this.cimaLocationSelectionoOpen = false;
    }
  }

  public closeCIMADoctorMessageSelection(status) {
    if (status === 'yes') {
      // check if selectedDoctorOption is In App / Push Message
      if (this.selectedDoctorOption === 'In App / Push Message') {
        // Email and Push DOCTOR
        if (this.doctorMessage === '' || this.doctorMessage == null) {
          this.notificationService.show({
            content: 'Please add message',
            animation: { type: 'slide', duration: 500 },
            position: { horizontal: 'center', vertical: 'bottom' },
            type: { style: 'error', icon: true },
            hideAfter: 2000
          });
        } else {
          // // Email and Push DOCTOR
          this.emailNotificationService.sendEmailAndPush(
            UserTypeEnum.DOCTOR,
            this.doctor.id,
            'WTD - Message',
            this.doctorMessage,
            NotificationType.APPOINTMENT_GENERAL,
            this.appointment.id
          )

          this.notificationService.show({
            content: 'Sent message to doctor.',
            animation: { type: 'slide', duration: 500 },
            position: { horizontal: 'center', vertical: 'bottom' },
            type: { style: 'success', icon: true },
            hideAfter: 2000
          });

          this.appointmentCollectionService.submitDoctorMessage(this.appointment.id, this.doctorMessage);
          this.logService.createAppointmentLog(this.appointment.id, LogType.DOCTOR_REMINDER);
        }
      } else {
        // CIMA
        if (this.doctor && this.doctor.phone) {
          // is valid phone number
          const phoneValidation = phone(this.doctor.phone, { country: '' });
          if (!phoneValidation.isValid) {
            this.notificationService.show({
              content: 'Not a valid phone number.',
              animation: { type: 'slide', duration: 500 },
              position: { horizontal: 'center', vertical: 'bottom' },
              type: { style: 'error', icon: true },
              hideAfter: 5000
            });
            return;
          } else {
            // capitalize first letter of the names
            const expertInfo = this.expert ? `${this.expert.first_name.charAt(0).toUpperCase() + this.expert.first_name.slice(1)} ${this.expert.last_name.charAt(0).toUpperCase() + this.expert.last_name.slice(1)}` : 'Expert';

            // get appointment date and time, convert to the experts timezone and format, for example: May 5th, 2021 at 3:00 PM PST
            const appointmentDateformatted = moment(this.appointment.appointment_date).tz(this.orgLocation?.timezone?.value).format('MMMM Do, YYYY');

            const appointmentTimeformatted = moment(this.appointment.appointment_date).tz(this.orgLocation?.timezone?.value).format('h:mm A z');

            const appointmentInfo = `Appointment: ${appointmentDateformatted} at ${appointmentTimeformatted} with ${expertInfo}`;

            this.emailNotificationService.sendCIMANotification(this.doctor, phoneValidation.phoneNumber, this.doctorMessage + ' - ' + appointmentInfo);
            // this.appointmentCollectionService.submitDoctorMessage(this.appointment.id, this.doctorMessage);
            this.logService.createAppointmentLog(this.appointment.id, LogType.DOCTOR_REMINDER_CIMA);

            this.notificationService.show({
              content: 'Sent message to doctor.',
              animation: { type: 'slide', duration: 500 },
              position: { horizontal: 'center', vertical: 'bottom' },
              type: { style: 'success', icon: true },
              hideAfter: 2000
            });
          }
        } else {
          this.notificationService.show({
            content: 'Not a valid phone number.',
            animation: { type: 'slide', duration: 500 },
            position: { horizontal: 'center', vertical: 'bottom' },
            type: { style: 'error', icon: true },
            hideAfter: 5000
          });
          return;
        }
      }

      this.cimaDoctorSelectionoOpen = false;
    } else {
      this.notificationService.show({
        content: 'Canceled',
        animation: { type: 'slide', duration: 500 },
        position: { horizontal: 'center', vertical: 'bottom' },
        type: { style: 'error', icon: true },
        hideAfter: 2000
      });
      this.cimaDoctorSelectionoOpen = false;
    }
  }

  handleEditTime() {
    this.updateTime = !this.updateTime;
    this.searchExperts = false;
    this.expertListLoaded = false;
  }

  onUpdateDateChange(value: Date) {
    this.value = value;
  }

  handleUpdateTime(time: any) {
    const newTime = moment(time).format();
    this.appointment.appointment_date = newTime;
    this.appointmentCollectionService.resubmitAppointment(this.appointment);
    this.logService.createAppointmentLog(this.appointment.id, LogType.APPOINTMENT_TIME_UPDATED);
    // TODO - firebase functions
    // this.appointmentCollectionService.createZoomMeeting(this.appointment);

    this.notificationService.show({
      content: `Updated to ${time.toString()}`,
      animation: { type: 'slide', duration: 500 },
      position: { horizontal: 'center', vertical: 'bottom' },
      type: { style: 'success', icon: true },
      hideAfter: 2000
    });
  }

  goBack() {
    this.location.back();
  }
}